import React from "react";
import "./skills.css";

export default function Skill() {
  return (
    <div id="skills">
      <div className="skills">
        <div className="title-skills">
          <h3 className="text1-skills animate__animated animate__fadeInUp wow">
            What i <span className="span-footer">know</span>
          </h3>
        </div>
        <div className="skill-content">
          <div className="main-contain">
            <h3 className="text3-skill animate__animated animate__fadeInUp wow">
              My creative skills <span>&</span> experiences.
            </h3>
            <p className="para-skill animate__animated animate__fadeInUp wow">
                <li className="animate__animated animate__fadeInUp wow">Designing and Developing user interactions on web pages.</li>
                <li className="animate__animated animate__fadeInUp wow">Developing back-end website applications.</li>
                <li className="animate__animated animate__fadeInUp wow">Creating servers and databases for functionality.</li>
                <li className="animate__animated animate__fadeInUp wow"> Ensuring cross-platform optimization for mobile phones and
                    desktop.</li>
                <li className="animate__animated animate__fadeInUp wow"> Ensuring responsiveness of applications and web pages.</li>
                <li className="animate__animated animate__fadeInUp wow">Working alongside as graphic designers for web design
                    features.</li>
                <p className="animate__animated animate__fadeInUp wow">You may also contact me for teaching you Full Stack Development.</p>
            </p>
          </div>
          <div className="main-contain">
              <div className="all-skills">
                  <div className="all-skills-div animate__animated animate__fadeInUp wow">
                      <h3 className="all-skills-h3 animate__animated animate__fadeInUp wow">HTML5</h3>
                      <progress id="file" value="90" max="100"></progress>
                  </div>
                  <div className="all-skills-div animate__animated animate__fadeInUp wow">
                      <h3 className="all-skills-h3  animate__animated animate__fadeInUp wow">CSS3</h3>
                      <progress id="file" value="90" max="100"></progress>
                  </div>
                  <div className="all-skills-div animate__animated animate__fadeInUp wow">
                      <h3 className="all-skills-h3 animate__animated animate__fadeInUp wow">JavaScript</h3>
                      <progress id="file" value="85" max="100"></progress>
                  </div>
                  <div className="all-skills-div animate__animated animate__fadeInUp wow">
                      <h3 className="all-skills-h3 animate__animated animate__fadeInUp wow">React Js</h3>
                      <progress id="file" value="80" max="100"></progress>
                  </div>
                  <div className="all-skills-div animate__animated animate__fadeInUp wow">
                      <h3 className="all-skills-h3 animate__animated animate__fadeInUp wow">Next Js</h3>
                      <progress id="file" value="70" max="100"></progress>
                  </div>
                  <div className="all-skills-div animate__animated animate__fadeInUp wow">
                      <h3 className="all-skills-h3 animate__animated animate__fadeInUp wow">Node Js</h3>
                      <progress id="file" value="60" max="100"></progress>
                  </div>
                  <div className="all-skills-div animate__animated animate__fadeInUp wow">
                      <h3 className="all-skills-h3">Python</h3>
                      <progress id="file" value="65" max="100"></progress>
                  </div>
                  <div className="all-skills-div animate__animated animate__fadeInUp wow">
                      <h3 className="all-skills-h3">Django</h3>
                      <progress id="file" value="70" max="100"></progress>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  );
}
